import { UpgradeAccount } from './UpgradeAccount';
export default UpgradeAccount;
